import type {ZodType} from "zod";
import {z as zod} from "zod";
import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";

export enum DAG_ConnectionAttemptSource {
    dataSourcePage = "ad984985-f77d-49ab-9e91-25d132b68a8f",
    onboardingPage = "c5b80ae5-aea5-4515-8882-a2c6c13e2f30",
    invalidCatchAll = "aaf14d87-42d2-4d71-a6d2-88d77d879811",
}

export function connectionAttemptSourceToDisplayName(source: DAG_ConnectionAttemptSource): string {
    switch (source) {
        case DAG_ConnectionAttemptSource.dataSourcePage: {
            return "Data sources page";
        }
        case DAG_ConnectionAttemptSource.onboardingPage: {
            return "Onboarding page";
        }
        case DAG_ConnectionAttemptSource.invalidCatchAll:
        default: {
            return "?";
        }
    }
}

// TODO: Scope this to the current accessToken/userId somehow?
export type DAG_ConnectionAttempt = {
    id: Uuid;
    createdAt: Iso8601DateTime;
    updatedAt: Iso8601DateTime;
    revisionId: Uuid;
    status: DAG_ConnectionAttemptStatus;
    // TODO: This is technically not source, but the.. placement? location?
    workspaceId: Uuid;
    dataSourceId: Uuid;
    currentStepId: Uuid;
    // TODO: Type this properly
    stepData: Record<Uuid, Record<string, unknown>>;
} & ({
    source: DAG_ConnectionAttemptSource.dataSourcePage;
} | {
    source: DAG_ConnectionAttemptSource.onboardingPage;
    onboardingJourneyId: Uuid;
});

export enum DAG_ConnectionAttemptStatus {
    inProgress = "e6c2a6ab-a071-4af0-b7ad-d8b18078a57c",
    succeeded = "460e0af9-9bb3-45b1-9ef2-5e563dc6d860",
    failed = "d665513e-b132-4c58-b3b1-f4346aad73ba",
    invalidCatchAll = "01fa3ec2-a48e-458c-b52a-5a01b0c2cead",
}

export const connectionAttemptZodValidator: ZodType<DAG_ConnectionAttempt> = zod.object({
    id: uuidZodValidator,
    createdAt: iso8601DateTimeZodValidator,
    updatedAt: iso8601DateTimeZodValidator,
    revisionId: uuidZodValidator,
    status: zod.enum(DAG_ConnectionAttemptStatus),
    workspaceId: uuidZodValidator,
    dataSourceId: uuidZodValidator,
    currentStepId: uuidZodValidator,
    stepData: zod.record(uuidZodValidator, zod.record(zod.string(), zod.unknown())),
}).and(zod.union([
    zod.object({
        source: zod.literal(DAG_ConnectionAttemptSource.dataSourcePage),
    }),
    zod.object({
        source: zod.literal(DAG_ConnectionAttemptSource.onboardingPage),
        onboardingJourneyId: uuidZodValidator,
    }),
]));

export function connectionAttemptStatusToDisplayName(status: DAG_ConnectionAttemptStatus): string {
    switch (status) {
        case DAG_ConnectionAttemptStatus.inProgress: {
            return "In progress";
        }
        case DAG_ConnectionAttemptStatus.succeeded: {
            return "Succeeded";
        }
        case DAG_ConnectionAttemptStatus.failed: {
            return "Failed";
        }
        case DAG_ConnectionAttemptStatus.invalidCatchAll:
        default: {
            return "?";
        }
    }
}
